var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip",class:this.positionClass,attrs:{"data-tooltip":_vm.time.full}},[_vm._v("\n    "+_vm._s(_vm.time.display)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }